import * as config from "../config.js";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const RETRIEVED_USER = "RETRIEVED_USER";
export const RETRIEVED_USERS = "RETRIEVED_USERS";
export const SAVED_USER = "SAVED_USER";
export const SAVING_USER = "SAVING_USER";
export const CLEAR_SAVED_USER = "CLEAR_SAVED_USER";
export const RETRIEVED_USER_TYPES = "RETRIEVED_USER_TYPES";

const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    user: user,
  };
};

const loginError = (error) => {
  return {
    type: LOGIN_ERROR,
    error: error,
  };
};

const logoutSuccess = (user) => {
  return {
    type: LOGOUT_SUCCESS,
  };
};

const savingUser = (saving) => {
  return {
    type: SAVING_USER,
    saving: saving,
  };
};

export const clearSavedUser = () => {
  return {
    type: CLEAR_SAVED_USER,
  };
};

export const logoutUser = () => {
  return (dispatch) => {
    dispatch(logoutSuccess());
  };
};

export const loadUser = (user) => {
  return (dispatch) => {
    dispatch(loginSuccess(user));
  };
};

const processLoginResponse = async (dispatch, response) => {
  if (response.success && response.token && response.user) {
    //setActiveUser(response.user);

    dispatch(loginSuccess(response.user));
  } else {
    dispatch(loginError(response.message));
  }
};

export const loginUser = (email, password) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    fetch(`${config.REST_SERVER_URL}/admin/login`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        processLoginResponse(dispatch, response);
      })
      .catch((error) => {
        dispatch(loginError(`Something was wrong. Try again: ${error}`, false));
      });
  };
};

export const getUser = (user_id) => {
  return (dispatch) => {
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/user/${user_id}`, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === false && data.logged_in === false) {
          dispatch(loginError("", false));
          return;
        }

        dispatch({
          type: RETRIEVED_USER,
          user: data.user,
        });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        dispatch(loginError(`Something was wrong. Try again: ${error}`, false));
      });
  };
};

export const getUsers = () => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/user`, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === false && data.logged_in === false) {
          dispatch(loginError("", false));
          return;
        }

        dispatch({
          type: RETRIEVED_USERS,
          users: data,
        });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        dispatch(loginError(`Something was wrong. Try again: ${error}`, false));
      });
  };
};

export const saveUser = (user) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    dispatch(savingUser(true));
    const method = user.public_id ? "PUT" : "POST";
    const url = user.public_id
      ? `${config.REST_SERVER_URL}/admin/user/${user.public_id}`
      : `${config.REST_SERVER_URL}/admin/user`;
    fetch(url, {
      method: method,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify(user),
    })
      .then((response) => response.json())
      .then((user) => {
        dispatch({
          type: SAVED_USER,
          savedUser: user,
        });

        // For now, just reload the users
        dispatch(getUsers());
      })
      .catch((error) =>
        dispatch(loginError(`Something was wrong. Try again: ${error}`, false))
      )
      .finally(() => {
        dispatch(savingUser(false));
      });
  };
};

export const getUserTypes = () => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/user/types`, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success === false && data.logged_in === false) {
          dispatch(loginError("", false));
          return;
        }
        dispatch({
          type: RETRIEVED_USER_TYPES,
          userTypes: data.usertypes,
        });
      })
      .catch((error) =>
        dispatch(loginError(`Something was wrong. Try again: ${error}`, false))
      );
  };
};
